import { Provider } from '@angular/core';

import { DYNAMIC_INJECTOR_PROVIDER_TOKEN } from '@frontend/sports/host-app/sports-product/feature/non-root-token';

import { SportsProductService } from './sports-product-service';

export function provideSportsDynamicInjector(): Provider[] {
    return [{ provide: DYNAMIC_INJECTOR_PROVIDER_TOKEN, useExisting: SportsProductService }];
}
